import { Controller } from "remult";

@Controller("team-field-config-methods")
export class TeamFieldConfigMethods {}
